import { Box, Typography, Button } from '@mui/material'
import { Link } from 'react-router-dom'
import FadeIn from '../components/animation/FadeIn'

export const NotFoundPage = () => {
  return (
    <FadeIn>
      <Box
        height="100dvh"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        textAlign="center"
      >
        <Typography variant="h1" fontWeight={700}>
          404
        </Typography>
        <Typography variant="h6" mt={1} mb={3}>
          Page not found
        </Typography>

        <Button
          component={Link}
          to="/"
          variant="contained"
        >
          Go back home
        </Button>
      </Box>
    </FadeIn>
  )
}
